<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div>
    <h1>特集商品提案状況</h1>
    <div>
      <wj-flex-grid #dtg_FeatureRequestList [itemsSource]="collectionview" [isReadOnly]="true" style="width: 1623px;"
        [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" 
        verticalScrollPolicy="'on'" forcedEnabledMode="true">
        <wj-flex-grid-filter #flr_FeatureRequestList></wj-flex-grid-filter>
        <!-- column チェックボックス -->
        <wj-flex-grid-column [header]="' '" [width]="80" [binding]="'check'" [align]="'center'" [isReadOnly]="true" 
          [cssClass]="'col-rowheader'" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="checkbox" class="selected" [checked]="cell.item.check" [disabled]="cell.item.disabled" 
              (click)="$event.stopPropagation();isPermittedCheck($event);" 
              [tabindex]="-1" (change)="onCheckChange(cell.item, $event)" forcedEnabledMode="none"/>
          </ng-template>
        </wj-flex-grid-column>
        <!-- column 企画回 -->
        <wj-flex-grid-column [header]="'企画回'" [width]="200" [binding]="'CatalogId'" [cssClass]="'col-rowheader'"
          [isReadOnly]="true" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div>{{formatCatalogId(cell.item.CatalogId)}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <!-- column 取引先名 -->
        <wj-flex-grid-column [header]="'取引先名'" [width]="510" [binding]="'SupplierNameKanji'" [isReadOnly]="true"
          [minWidth]="5">
        </wj-flex-grid-column>
        <!-- column 特集コード -->
        <wj-flex-grid-column [header]="'特集コード'" [width]="150" [binding]="'FeatureCode'" [isReadOnly]="true"
          [minWidth]="5">
        </wj-flex-grid-column>
        <!-- column 特集名 -->
        <wj-flex-grid-column [header]="'特集名'" [width]="510" [binding]="'FeatureName'" [isReadOnly]="true"
          [minWidth]="5">
        </wj-flex-grid-column>
        <!-- column ステータス -->
        <wj-flex-grid-column [header]="'ステータス'" [width]="155" [binding]="'statusName'" [isReadOnly]="true"
          [minWidth]="5">
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button #btn_Confirmed id="btn_Confirmed" class="btn-primary" forcedEnabledMode="none" [tabindex]="0" (click)="update()">確定</button>
</footer>